module.exports = __webpack_public_path__ + "static/media/marelli.53501d2a.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/brand/cards-benefits/cards-new/marelli.png
// module id = 2113
// module chunks = 18